<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.query.lcCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.query.matCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.query.beginTime" value-format="yyyy-MM-dd" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                  <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="pagination.query.endTime" value-format="yyyy-MM-dd" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData(), getSum()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
              
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.query.batchNo">
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="收发存汇总表报表">
                <span style="font-weight: bolder">出库总量：{{ outSum }}</span>
                <span style="margin-left: 50px;margin-right: 50px; font-weight: bolder">入库总量：{{ inSum }}</span>
                <el-button v-authority="'BACK_MENU7_M10_B1'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="pagination.headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="pagination.data" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="wirId" label="序号" /> -->
                <el-table-column prop="lcCode" label="库位编号" />
                <el-table-column prop="matCode" label="物料编号" />
                <el-table-column prop="matName" label="物料描述" />
                <el-table-column prop="matQuan" label="物料数量" />
                <el-table-column prop="batchNo" label="批号" />
                <el-table-column prop="wirType" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wirType == 'IN'">入库</span>
                        <span v-if="scope.row.wirType == 'OUT'">出库</span>
                    </template>
                </el-table-column>
                <el-table-column prop="person" label="操作人" />
                <el-table-column prop="createTime" label="创建时间" />
            </h-table>
        </box>
    </div>
</template>

<script>
    export default {
        name: "inventoryRecordIn",
        data() {
            return {
                pagination: {
                    query:{
                        fcCode: localStorage.getItem("fcCode") || "",
                        person: localStorage.getItem("user") || "",
                        matCode: "",
                        lcCode: "",
                        batchNo: "",
                        matName: "",
                        beginTime:"", 
                        endTime:"",
                    },
                    data: [],
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f5cec";
                    },
                },

                inSum: "",
                outSum:"",
                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            "pagination.query": {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true
            }
        },
        computed: {
            startPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.query.endTime) {
                            return time.getTime() < new Date(_this.pagination.query.endTime);
                        }
                    }
                }
            },
            finishPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.pagination.query.beginTime) {
                            return time.getTime() < new Date(_this.pagination.query.beginTime);
                        }
                    }
                }
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/inventoryRecord/getInventoryConfluence",
                        method: "GET",
                        params: {
                            pageNum: this.pagination.pageNum || null,
                            pageSize: this.pagination.pageSize || null,
                            fcCode: this.pagination.query.fcCode || null,
                            person: this.pagination.query.person || null,
                            matCode: this.pagination.query.matCode || null,
                            lcCode: this.pagination.query.lcCode || null,
                            batchNo: this.pagination.query.batchNo || null,
                            beginTime: this.pagination.query.beginTime || null,
                            endTime: this.pagination.query.endTime || null,
                        },
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            this.pagination.data = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                        this.getSum();
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },

            //获取数据
            getSum() {
                this.$http
                    .request({
                        url: "/api/inventoryRecord/getSum",
                        method: "GET",
                        params: {
                            person: this.pagination.query.person || null,
                            matCode: this.pagination.query.matCode || null,
                            lcCode: this.pagination.query.lcCode || null,
                            batchNo: this.pagination.query.batchNo || null,
                            fcCode: this.pagination.query.fcCode || null,
                            beginTime: this.pagination.query.beginTime || null,
                            endTime: this.pagination.query.endTime || null,
                        },
                    })
                    .then((resp) => {
                        this.loading--;
                        if (resp.status == 100) {
                            this.inSum = resp.data.list[0].inSum;
                            this.outSum = resp.data.list[0].outSum;
                        }
                    })
                    .catch((error) => {
                        this.loading--;
                    });
            },
            //重置
            resetData() {
                this.pagination.query = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    person: localStorage.getItem("user") || "",
                    matCode: "",
                    lcCode: "",
                    batchNo: "",
                    matName: "",
                    beginTime:"", 
                    endTime:"",
                };
                // this.pagination = {
                //     pageNum: 1,
                //     pageSize: 50,
                //     total: 0,
                //     matCode: "",
                //     lcCode: "",
                //     batchNo: "",
                //     matName: "",
                //     beginTime: "",
                //     endTime: "",
                //     fcCode: localStorage.getItem("fcCode") || "",
                //     person: localStorage.getItem("user"),
                // };
                // this.date = [];
                // // this.addDate();
                // this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    person: this.pagination.query.person,
                    matCode: this.pagination.query.matCode || null,
                    lcCode: this.pagination.query.lcCode || null,
                    batchNo: this.pagination.query.batchNo || null,
                    fcCode: this.pagination.query.fcCode || null,
                    beginTime: this.pagination.query.beginTime || null,
                    endTime: this.pagination.query.endTime || null,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/inventoryRecord/getInventoryConfluence',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.wirType == "IN") {
                            c['wirType'] = '入库'
                        } else if (c.wirType == "OUT") {
                            c['wirType'] = '出库'
                        }
                    })
                    const tHeader = ['库位编号', '物料编号', '物料描述', '物料数量', '批号', '类型', '操作人', '创建时间']
                    const filterVal = ['lcCode', 'matCode', 'matName', 'matQuan', 'batchNo', 'wirType', 'person', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '收发总库存汇总报表数据'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "wh_inventory_record：导出收发总库存汇总报表数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "收发存汇总表报表",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>